import React from 'react';

import MyTicketsContainer, {
  containerConfiguration,
} from '@totem/components/ticketing/myTickets/myTicketsContainer';
import MyTicketsLayout from '@totem/components/ticketing/myTickets/myTicketsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

const MyTicketsPage = () => {
  return (
    <ContentLayout>
      <InputContainer
        filterConfig={containerConfiguration}
        defaultSort={{
          field: 'createdAt',
          direction: 'descend',
        }}
        defaultFilters={[
          {
            field: 'status',
            values: ['OPEN', 'RESOLVED'],
          },
        ]}
        componentKey={'dashboard.myTickets'}
        componentLabel={'My Tickets'}
      >
        <MyTicketsContainer>
          <IBCard isCovered>
            <MyTicketsLayout />
          </IBCard>
        </MyTicketsContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default MyTicketsPage;
